// extracted by mini-css-extract-plugin
export default {"wrapper":"TrademarkActions_wrapper__mcvea","horizontal":"TrademarkActions_horizontal__j278d"};